import { useSyncExternalStore } from "react";

let pending = 0;
const listeners = new Set<() => void>();

const emit = () => listeners.forEach((listener) => listener());

/** Marks a page load as running until `request` settles. */
export const trackPageLoad = (request: Promise<unknown>) => {
    pending++;
    emit();
    const done = () => {
        pending--;
        emit();
    };
    request.then(done, done);
};

const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

/** True while any page is waiting for its data. */
export const usePageLoading = () => useSyncExternalStore(subscribe, () => pending > 0);
